const keyCode = {
  ENTER: 13,
  UP: 38,
  DOWN: 40,
};

const searchHelperType = {
  NONE: 'search:none',
  INSTANT: 'search:instant',
  HISTORY: 'search:history',
};

class SearchHelper {
  constructor($wrapper) {
    this.useHighlight = Ridi.globals.isPc;
    this.$wrapper = $wrapper;
  }

  keyboardAction(e) {
    if (!this.useHighlight) return;

    if (e.which === keyCode.DOWN || e.which === keyCode.UP) {
      e.preventDefault();
      this.moveHighlight(e.which === keyCode.DOWN ? 1 : -1);
    }
  }

  setHighlightAt(i, $currentSelected) {
    $currentSelected.removeClass('highlight');
    const $target = this.$wrapper.find(`li[data-index=${i}]`);
    if ($target.length > 0) {
      $target.addClass('highlight');
    }
  }

  getUpperBound() {
    // over-ride method
  }

  moveHighlight(i) {
    const upperBound = this.getUpperBound();
    if (!upperBound) return;
    const $currentSelected = this.$wrapper.find('.highlight');
    const currentIndex = $currentSelected.length > 0 ? parseInt($currentSelected.data('index'), 10) : -1;
    let desiredIndex = (currentIndex + i) % upperBound;
    if (desiredIndex < 0) desiredIndex += upperBound;
    this.setHighlightAt(desiredIndex, $currentSelected);
  }

  clearHighlight() {
    const $currentSelected = this.$wrapper.find('.highlight');
    if ($currentSelected) {
      $currentSelected.removeClass('highlight');
    }
  }
}

export { SearchHelper, keyCode, searchHelperType };



// WEBPACK FOOTER //
// ./common/search.helper.js